import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=35ff0ae4"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports